var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenStackDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.682 40H54.6695C45.5013 40 38 47.5013 38 56.6695V95.8738H78.4391V89.453C78.4391 84.4675 82.483 80.4391 87.4529 80.4391H167.868C172.853 80.4391 176.882 84.483 176.882 89.453V95.8738H217.321V56.6695C217.321 47.5013 209.82 40 200.651 40H200.682Z",
    fill: "#ED1844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.53 166.102C177.53 171.087 173.486 175.116 168.516 175.116H88.1011C83.1157 175.116 79.0873 171.072 79.0873 166.102V159.681H38.6482V198.885C38.6482 208.054 46.1495 215.555 55.3177 215.555H201.331C210.499 215.555 218 208.054 218 198.885V159.681H177.561L177.53 166.102Z",
    fill: "#ED1844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6172 107.604V148.043H78.7476V107.604H38.6172Z",
    fill: "#ED1844"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.53 107.604V148.043H217.661V107.604H177.53Z",
    fill: "#ED1844"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenStackDark);
export default __webpack_public_path__ + "static/media/OpenStack-Dark.47f5f1c72e12a75bcaeb6b0a195dd462.svg";
export { ForwardRef as ReactComponent };